import { UserService } from "@/services";
import { util } from "@/helpers";
export default {
  async deleteFlow({ commit }, payload) {
    commit("SET_STATUS", 0);
    commit("SET_IS_FETCHING", true);
    try {
      const { data } = await UserService.deleteAccount(payload);
      console.log("delete account data here ", data);
      if (data?.successFlag) {
        commit("SET_STATUS", 1);
        commit("SET_RESPONSE", data);
        return data;
      } else {
        commit("SET_STATUS", 2);
        console.log("err", data?.errCode);
        const errMsg = util.getUiErrorByCode(data?.errCode);
        commit(
          "alert/SHOW_ALERT",
          {
            message: errMsg,
            type: "error",
          },
          { root: true }
        );
        document.getElementById("app").scrollIntoView({ behavior: "smooth" });
      }
    } catch (e) {
      commit("SET_STATUS", 2);
      // console.error(e);
      commit("SET_RESPONSE", e.response?.data);
      const errCode = e.response?.data?.errCode ?? e.response.status;
      const errMsg = util.getUiErrorByCode(errCode);
      commit(
        "alert/SHOW_ALERT",
        {
          message: errMsg,
          type: "error",
        },
        { root: true }
      );
      document.getElementById("app").scrollIntoView({ behavior: "smooth" });
      return e?.response?.data;
    } finally {
      commit("SET_IS_FETCHING", false);
    }
  },
};
